import { alpha } from "@mui/material/styles";

export const colors = {
  greyBlack: {
    10: alpha("#0c2133", 0.05),
    20: alpha("#0c2133", 0.11),
    30: alpha("#0c2133", 0.21),
    40: alpha("#0c2133", 0.32),
    50: alpha("#0c2133", 0.45),
    60: alpha("#0c2133", 0.58),
    80: alpha("#0c2133", 0.78),
  },
  greyWhite: {
    10: alpha("#f5f7ff", 0.11),
    20: alpha("#f5f7ff", 0.19),
    30: alpha("#f2f7ff", 0.29),
    40: alpha("#eef4ff", 0.43),
    50: alpha("#eef4ff", 0.53),
    60: alpha("#eef4ff", 0.67),
  },

  primaryRed: "#E25454",
  primaryBlack: "#0C0C0C",
  primaryStroke: "#3D3D3D",
  secondaryStroke: "#292929",
  primaryGrey: "#1B1B1B",
};
